import {Injectable} from "@angular/core";
import {FactoryInterface} from "../factory.interface";

@Injectable()
export class DivisionsFactory implements FactoryInterface {
    build() {
        return [
            {code: 1, label: "Omnik"}
        ]
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/factories/dropdown/divisions.factory.ts